import ListItemFence from '@/components/Geofences/ListItemFence'
import ListItemRelationships from '@/components/Geofences/ListItemRelationships'
import { sanitizeModel } from '@/common/utils/modelDecorator'

export default {
  computed: {
    geofencesModel() {
      return sanitizeModel({
        title: 'Geofences',
        endpoint: this.$appConfig.api.baseUrl + 'geo-fences',
        allowNew: true,
        listExtrasComponent: () => import('@/components/Geofences/ListExtras'),
        allowDelete: true,
        fields: [
          {
            key: 'id',
            sortable: true,
            label: this.$gettext('ID')
          },
          {
            key: 'geo_type_id',
            sortable: true,
            editable: false,
            label: this.$gettext('Geo Type'),
            formatter: (value, key, item) => {
              return this.$store.getters.geoTypes.find(x => x.id === item.geo_type_id).name
            }
          },
          {
            key: 'name',
            sortable: true,
            editable: false,
            label: this.$gettext('Name')
          },
          {
            key: 'reference_location',
            sortable: true,
            editable: true,
            label: this.$gettext('Reference Location')
          },
          {
            key: 'external_id',
            sortable: false,
            editable: true,
            label: this.$gettext('External ID')
          },
          {
            key: 'fence',
            sortable: false,
            editable: true,
            label: this.$gettext('Fence'),
            component: (value, key, item) => {
              return {
                is: ListItemFence,
                geofence: item
              }
            }
          },
          {
            key: 'relationships',
            sortable: false,
            editable: false,
            label: this.$gettext('Relationships'),
            component: (value, key, item) => {
              return {
                is: ListItemRelationships,
                geofence: item
              }
            }
          },
          {
            key: 'timezone',
            sortable: false,
            editable: true,
            label: this.$gettext('Timezone')
          },
          {
            key: 'created_at',
            sortable: true,
            editable: false,
            label: this.$gettext('Created At'),
            formatter: (value, key, item) => {
              return this.moment.utc(value).tz(this.$tz).format('L') + '<br>' +
                this.moment.utc(value).tz(this.$tz).format('LT')
            }
          },
          {
            key: 'updated_at',
            sortable: true,
            editable: false,
            label: this.$gettext('Last Updated'),
            formatter: (value, key, item) => {
              return this.moment.utc(value).tz(this.$tz).format('L') + '<br>' +
                this.moment.utc(value).tz(this.$tz).format('LT')
            }
          }
        ],
        extraActions: [
          {
            label: '',
            type: () => import('@/components/Geofences/ListItemActions'), // external bunch of actions
            position: 'start',
            hideCondition: (item) => {
              return item.geo_type.level !== 0
            },
            props: (item) => {
              return {
                item,
                type: 'geofences'
              }
            }
          },
          {
            type: 'b-dropdown-divider',
            position: 'start',
            hideCondition: (item) => {
              return item.geo_type.level !== 0 || !this.isSuperAdmin
            }
          }
        ],
        filters: [
          'id',
          'name',
          'reference_location',
          'external_id',
          'geo_type.name'
        ],
        includes: [
          'geo_type',
          'geo_fences.geo_type',
          'geo_lines.geo_type',
          'geo_points.geo_type'
        ],
        exclude: [
          'meta'
        ]
      })
    },
    geofencesTrackingHistoryEvents() {
      return sanitizeModel({
        title: 'Geofences Tracking History Events',
        endpoint: this.$appConfig.api.baseUrl + 'items-tracking/history/events',
        listExtrasComponent: () => import('@/components/Geofences/TrackingHistoryEventsListExtras'),
        allowNew: false,
        allowSelect: false,
        noActions: true,
        fields: [
          {
            key: 'created_at',
            sortable: true,
            editable: false,
            label: this.$gettext('Event Date'),
            formatter: (value, key, item) => {
              return this.$options.filters.tabledate(value, this.$tz, this.frontConfig.i18n.moment)
            }
          },
          {
            key: 'item_id',
            sortable: false,
            label: this.$gettext('Event'),
            class: 'text-center',
            formatter: (value, key, item) => {
              let html = '<div class="d-flex">'
              if (item.event_name === 'entry') {
                html += `<div class="flex-fill h4 text-right"><span class="badge badge-dark">${item.item.reference_code}</span></div>`
                html += '<div class="flex-fill h4 text-center mx-2"><i class="fas fa-arrow-circle-right"></i><i class="fas fa-arrow-circle-right"></i><i class="fas fa-arrow-circle-right"></i></div>'
                html += `<div class="flex-fill text-left"><strong>${item.owner.external_id}</strong> ${item.owner.name}</div>`
              } else if (item.event_name === 'exit') {
                html += `<div class="flex-fill text-right"><strong>${item.owner.external_id}</strong> ${item.owner.name}</div>`
                html += '<div class="flex-fill h4 text-center mx-2"><i class="fas fa-arrow-circle-right"></i><i class="fas fa-arrow-circle-right"></i><i class="fas fa-arrow-circle-right"></i></div>'
                html += `<div class="flex-fill h4 text-left"><span class="badge badge-dark">${item.item.reference_code}</span></div>`
              }
              html += '</div>'
              return html
            }
          }
        ],
        includes: [
          'item',
          'owner'
        ],
        filters: [],
        exclude: []
      })
    }
  }
}
